import styled from "styled-components";

export const Container = styled.div`
  flex-direction: row;
  //width: 684px;
  justify-content: space-between;
  width: 100%;
  padding-top: 15px;


  & div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    //width: 310px;
    width: 100%;
  }

  input.invalid {
    border-color: red;
  }
  p.invalid {
    color: red;
    display: block;
  }

  .validation-error {
    background: rgba(255, 0, 0, 0.1);
    color: rgba(255, 2, 2, 1);
    font-size: 12px;
    font-weight: 400;
    border-radius: 10px;
    padding: 0.5em;
    margin-top: 1em;
    user-select: all;
    display: inline-block;
  }

  .hidden {
    display: none;
  }
  `;
